import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Hobby from '../views/Hobby.vue'
// import Contact from '../views/Contact.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: { title: 'AL' }
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		meta: { title: 'AL' }
	},
	{
		path: '/hobby',
		name: 'hobby',
		component: Hobby,
		meta: { title: 'AL - Loisirs' }
	}
	// {
	// 	path: '/contact',
	// 	name: 'contact',
	// 	component: Contact,
	// 	meta: { title: 'AL - Contact' }
	// }
	// {
	// 	path: '/about',
	// 	name: 'about',
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	// }
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title
	next()
})

export default router
